import { render } from "./IconsQuestion.vue?vue&type=template&id=3392d8b6&scoped=true"
import script from "./IconsQuestion.vue?vue&type=script&lang=js"
export * from "./IconsQuestion.vue?vue&type=script&lang=js"

import "./IconsQuestion.vue?vue&type=style&index=0&id=3392d8b6&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3392d8b6"]])

export default __exports__